import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  // padding: 0 2rem;
`;

export const MessageBox = styled.p`
  width: 100%;
  color: #5c576b;
  text-align: center;
  padding: 22px 72px;
  border-radius: 8px;
  border: 1px solid #24222a;
`;
